/**
 * Portfolio project data for Jojo & Jocelyn
 * Showcasing before-and-after transformations
 */

export interface PortfolioProject {
  id: string;
  title: string;
  category: 'upholstery' | 'window-treatments';
  serviceType: string; // Specific service (e.g., 'sofa-reupholstery')
  description: string;
  beforeImage?: string;
  afterImage?: string;
  galleryImages?: Array<{ id: string; src: string; alt: string; type?: 'before' | 'after' | 'showcase' }>;
  featured: boolean;
  details: {
    client: string;
    duration: string;
    fabric?: string;
    challenge?: string;
  };
}

export const portfolioProjects: PortfolioProject[] = [
  // Upholstery Projects
  {
    id: 'sofa-restoration-gallery',
    title: 'Sofa Restoration Showcase',
    category: 'upholstery',
    serviceType: 'sofa-restoration',
    description: 'Our expert sofa restoration work brings tired, worn sofas back to life. Each piece receives meticulous craftsmanship, from frame repairs to premium fabric selection. Explore our collection of stunning transformations.',
    featured: true,
    galleryImages: [
      {
        id: 'sofa-1',
        src: '/images/uploads/9abd8fb9-7651-41c5-9771-07fa49c24b75.jpg',
        alt: 'Professional Sofa Restoration - Showcase 1',
        type: 'showcase',
      },
      {
        id: 'sofa-2',
        src: '/images/uploads/82ece53d-d1b9-4caa-afdc-d14af65082a6.jpg',
        alt: 'Professional Sofa Restoration - Showcase 2',
        type: 'showcase',
      },
      {
        id: 'sofa-3',
        src: '/images/uploads/25347f0f-78ca-4c61-a3b4-a6d74f366a57.jpg',
        alt: 'Professional Sofa Restoration - Showcase 3',
        type: 'showcase',
      },
      {
        id: 'sofa-4',
        src: '/images/uploads/2e024293-a484-4c41-b969-05af4fd5e7d0.jpg',
        alt: 'Professional Sofa Restoration - Showcase 4',
        type: 'showcase',
      },
      {
        id: 'sofa-5',
        src: '/images/uploads/f473c755-cf1a-4330-acf4-0397b10bde7f.jpg',
        alt: 'Professional Sofa Restoration - Showcase 5',
        type: 'showcase',
      },
      {
        id: 'sofa-6',
        src: '/images/uploads/2fabff77-a0a8-49d6-94e8-49e7d38fe585.jpg',
        alt: 'Professional Sofa Restoration - Showcase 6',
        type: 'showcase',
      },
      {
        id: 'sofa-7',
        src: '/images/uploads/ec9acd78-99fa-42e7-a5ca-666ef43d359c.jpg',
        alt: 'Professional Sofa Restoration - Showcase 7',
        type: 'showcase',
      },
      {
        id: 'sofa-8',
        src: '/images/uploads/f30ddd6a-7594-463f-bc0b-549324c51cbc.jpg',
        alt: 'Professional Sofa Restoration - Showcase 8',
        type: 'showcase',
      },
      {
        id: 'sofa-9',
        src: '/images/uploads/1622147e-bfa8-4914-bfc2-cc3ffb75a7b9.jpg',
        alt: 'Professional Sofa Restoration - Showcase 9',
        type: 'showcase',
      },
      {
        id: 'sofa-10',
        src: '/images/uploads/8806cee0-be84-43e5-9b9f-d599e15b8d2c.jpg',
        alt: 'Professional Sofa Restoration - Showcase 10',
        type: 'showcase',
      },
      {
        id: 'sofa-11',
        src: '/images/uploads/d7cb1df4-f0f4-4f52-96cb-6b8ec396394b.jpg',
        alt: 'Professional Sofa Restoration - Showcase 11',
        type: 'showcase',
      },
      {
        id: 'sofa-12',
        src: '/images/uploads/bc5dad2d-beb6-4972-8ab5-d680a9723bc0.jpg',
        alt: 'Professional Sofa Restoration - Showcase 12',
        type: 'showcase',
      },
      {
        id: 'sofa-13',
        src: '/images/uploads/ac41fe72-db1d-43cc-bd31-de6e67366bfc.jpg',
        alt: 'Professional Sofa Restoration - Showcase 13',
        type: 'showcase',
      },
      {
        id: 'sofa-14',
        src: '/images/uploads/dbe525ca-90bc-4333-b481-fc00fb2cbad1.jpg',
        alt: 'Professional Sofa Restoration - Showcase 14',
        type: 'showcase',
      },
      {
        id: 'sofa-15',
        src: '/images/uploads/1012f527-01f9-4dfc-869c-1c8e403383ac.jpg',
        alt: 'Professional Sofa Restoration - Showcase 15',
        type: 'showcase',
      },
      {
        id: 'sofa-16',
        src: '/images/uploads/22fd3074-8bbd-44cf-9d40-16a283087fb6.jpg',
        alt: 'Professional Sofa Restoration - Showcase 16',
        type: 'showcase',
      },
      {
        id: 'sofa-17',
        src: '/images/uploads/12520417-99f3-4f8a-b449-ac102353ff43.jpg',
        alt: 'Professional Sofa Restoration - Showcase 17',
        type: 'showcase',
      },
      {
        id: 'sofa-18',
        src: '/images/uploads/b10e56a4-00bd-47a2-b6de-ae6036443393.jpg',
        alt: 'Professional Sofa Restoration - Showcase 18',
        type: 'showcase',
      },
      {
        id: 'sofa-19',
        src: '/images/uploads/fa438a1b-734d-4ed2-8d37-f8f1bcca876e.jpg',
        alt: 'Professional Sofa Restoration - Showcase 19',
        type: 'showcase',
      },
      {
        id: 'sofa-20',
        src: '/images/uploads/dc88d6b4-cb30-4c98-ae19-d93296c2058c.jpg',
        alt: 'Professional Sofa Restoration - Showcase 20',
        type: 'showcase',
      },
      {
        id: 'sofa-21',
        src: '/images/uploads/4fb575d3-f6c6-4db4-a15d-c6f194fe025b.jpg',
        alt: 'Professional Sofa Restoration - Showcase 21',
        type: 'showcase',
      },
      {
        id: 'sofa-22',
        src: '/images/uploads/35623a59-da64-4093-a4ba-aa4ce695a3ee.jpg',
        alt: 'Professional Sofa Restoration - Showcase 22',
        type: 'showcase',
      },
      {
        id: 'sofa-23',
        src: '/images/uploads/9cc0aae5-f6e9-4369-8a80-7747ee010212.jpg',
        alt: 'Professional Sofa Restoration - Showcase 23',
        type: 'showcase',
      },
      {
        id: 'sofa-24',
        src: '/images/uploads/e55bdebb-deda-4d30-a519-244fd84a7edd.jpg',
        alt: 'Professional Sofa Restoration - Showcase 24',
        type: 'showcase',
      },
      {
        id: 'sofa-25',
        src: '/images/uploads/679ded9a-e4c7-4abc-b789-fb4c23acf068.jpg',
        alt: 'Professional Sofa Restoration - Showcase 25',
        type: 'showcase',
      },
      {
        id: 'sofa-26',
        src: '/images/uploads/c1ee7570-13b5-4549-a8cf-12bf89977377.jpg',
        alt: 'Professional Sofa Restoration - Showcase 26',
        type: 'showcase',
      },
      {
        id: 'sofa-27',
        src: '/images/uploads/39cc706a-75ac-4c58-94f6-41445e278813.jpg',
        alt: 'Professional Sofa Restoration - Showcase 27',
        type: 'showcase',
      },
      {
        id: 'sofa-28',
        src: '/images/uploads/8d847de5-5b44-452b-8691-e81e837b9f1e.jpg',
        alt: 'Professional Sofa Restoration - Showcase 28',
        type: 'showcase',
      },
      {
        id: 'sofa-29',
        src: '/images/uploads/873185cd-3082-48c8-816f-5619b16ba3f8.jpg',
        alt: 'Professional Sofa Restoration - Showcase 29',
        type: 'showcase',
      },
      {
        id: 'sofa-30',
        src: '/images/uploads/c2cb604b-1f0b-4873-9f2d-6f4c7024be66.jpg',
        alt: 'Professional Sofa Restoration - Showcase 30',
        type: 'showcase',
      },
      {
        id: 'sofa-31',
        src: '/images/uploads/3fb7a632-0eeb-4713-a8dd-df708b0b5497.jpg',
        alt: 'Professional Sofa Restoration - Showcase 31',
        type: 'showcase',
      },
      {
        id: 'sofa-32',
        src: '/images/uploads/3879748f-33d7-43f3-b3f5-d21681c77cb4.jpg',
        alt: 'Professional Sofa Restoration - Showcase 32',
        type: 'showcase',
      },
      {
        id: 'sofa-33',
        src: '/images/uploads/82b0ab02-7546-4851-9875-bb630e7e5f3d.jpg',
        alt: 'Professional Sofa Restoration - Showcase 33',
        type: 'showcase',
      },
      {
        id: 'sofa-34',
        src: '/images/uploads/2c00dc1f-3136-46e7-9c78-895ecca1978b.jpg',
        alt: 'Professional Sofa Restoration - Showcase 34',
        type: 'showcase',
      },
      {
        id: 'sofa-35',
        src: '/images/uploads/b40e3524-b2e8-4d6f-9bed-ff9000867454.jpg',
        alt: 'Professional Sofa Restoration - Showcase 35',
        type: 'showcase',
      },
      {
        id: 'sofa-36',
        src: '/images/uploads/a9318cc3-e523-4cfe-9f27-090223f467cc.jpg',
        alt: 'Professional Sofa Restoration - Showcase 36',
        type: 'showcase',
      },
      {
        id: 'sofa-37',
        src: '/images/uploads/542e9171-414b-4b8c-8418-dddf3a26f44d.jpg',
        alt: 'Professional Sofa Restoration - Showcase 37',
        type: 'showcase',
      },
      {
        id: 'sofa-38',
        src: '/images/uploads/1404868b-6c92-4543-a5ea-ce462c66322e.jpg',
        alt: 'Professional Sofa Restoration - Showcase 38',
        type: 'showcase',
      },
      {
        id: 'sofa-39',
        src: '/images/uploads/bbb95755-de68-4ef4-bd62-7d0e622c8a3a.jpg',
        alt: 'Professional Sofa Restoration - Showcase 39',
        type: 'showcase',
      },
      {
        id: 'sofa-40',
        src: '/images/uploads/98bb45aa-b317-4de0-90c4-0946deaaefcb.jpg',
        alt: 'Professional Sofa Restoration - Showcase 40',
        type: 'showcase',
      },
      {
        id: 'sofa-41',
        src: '/images/uploads/1f60792f-f3ce-42dc-839b-309d27856226.jpg',
        alt: 'Professional Sofa Restoration - Showcase 41',
        type: 'showcase',
      },
      {
        id: 'sofa-42',
        src: '/images/uploads/a4dc218d-fc8a-4664-95ef-7263de2e855a.jpg',
        alt: 'Professional Sofa Restoration - Showcase 42',
        type: 'showcase',
      },
      {
        id: 'sofa-43',
        src: '/images/uploads/1b6bb6e5-e8ac-4097-892c-b49b9b218db8.jpg',
        alt: 'Professional Sofa Restoration - Showcase 43',
        type: 'showcase',
      },
      {
        id: 'sofa-44',
        src: '/images/uploads/70281d81-d61e-4e90-9fcb-bae688fe323f.jpg',
        alt: 'Professional Sofa Restoration - Showcase 44',
        type: 'showcase',
      },
      {
        id: 'sofa-45',
        src: '/images/uploads/b9055b20-f18d-4fe9-9385-f2e60fc5580f.jpg',
        alt: 'Professional Sofa Restoration - Showcase 45',
        type: 'showcase',
      },
      {
        id: 'sofa-46',
        src: '/images/uploads/dacdf480-b8a9-4e01-a21c-11c67dc7a483.jpg',
        alt: 'Professional Sofa Restoration - Showcase 46',
        type: 'showcase',
      },
      {
        id: 'sofa-47',
        src: '/images/uploads/c766c7a4-c2c7-47fd-9342-989f5792b136.jpg',
        alt: 'Professional Sofa Restoration - Showcase 47',
        type: 'showcase',
      },
      {
        id: 'sofa-48',
        src: '/images/uploads/1cd77dfa-dd76-4e69-8663-be81239986a6.jpg',
        alt: 'Professional Sofa Restoration - Showcase 48',
        type: 'showcase',
      },
      {
        id: 'sofa-49',
        src: '/images/uploads/8d543329-9863-435a-ad38-29db7cf39743.jpg',
        alt: 'Professional Sofa Restoration - Showcase 49',
        type: 'showcase',
      },
      {
        id: 'sofa-50',
        src: '/images/uploads/d301d4d6-eef5-419c-b596-c00778da1d75.jpg',
        alt: 'Professional Sofa Restoration - Showcase 50',
        type: 'showcase',
      },
      {
        id: 'sofa-51',
        src: '/images/uploads/813c5a96-7182-4a4d-b916-04e297a12288.jpg',
        alt: 'Professional Sofa Restoration - Showcase 51',
        type: 'showcase',
      },
      {
        id: 'sofa-52',
        src: '/images/uploads/1d37ef6b-4830-4361-9b10-5f3f14469a3e.jpg',
        alt: 'Professional Sofa Restoration - Showcase 52',
        type: 'showcase',
      },
      {
        id: 'sofa-53',
        src: '/images/uploads/2eb26211-de81-4653-ad87-9c9ca1431d51.jpg',
        alt: 'Professional Sofa Restoration - Showcase 53',
        type: 'showcase',
      },
      {
        id: 'sofa-54',
        src: '/images/uploads/4ac21831-1825-4804-a73b-9fd3ff9240c0.jpg',
        alt: 'Professional Sofa Restoration - Showcase 54',
        type: 'showcase',
      },
      {
        id: 'sofa-55',
        src: '/images/uploads/c63e8a9c-204a-46b0-8913-b6b9fbcdcea9.jpg',
        alt: 'Professional Sofa Restoration - Showcase 55',
        type: 'showcase',
      },
      {
        id: 'sofa-56',
        src: '/images/uploads/90231f90-efa6-4415-9765-a15eed140ab8.jpg',
        alt: 'Professional Sofa Restoration - Showcase 56',
        type: 'showcase',
      },
      {
        id: 'sofa-57',
        src: '/images/uploads/a9dc242a-3d36-44f9-86e9-802c4c0dead5.jpg',
        alt: 'Professional Sofa Restoration - Showcase 57',
        type: 'showcase',
      },
    ],
    details: {
      client: 'Multiple Clients',
      duration: 'Varies by project',
      fabric: 'Premium upholstery fabrics',
      challenge: 'Custom restoration tailored to each piece\'s unique needs',
    },
  },
  {
    id: 'victorian-sofa-restoration',
    title: 'Victorian Sofa Restoration',
    category: 'upholstery',
    serviceType: 'furniture-restoration',
    description: 'A stunning 1890s Victorian sofa brought back to its original grandeur. We restored the ornate wooden frame, replaced worn springs, and reupholstered in period-appropriate velvet.',
    beforeImage: '/images/portfolio/victorian-sofa-before.jpg',
    afterImage: '/images/portfolio/victorian-sofa-after.jpg',
    featured: true,
    details: {
      client: 'Heritage Home Collection',
      duration: '3 weeks',
      fabric: 'Ruby red velvet with gold piping',
      challenge: 'Matching original carved wood details while reinforcing structural integrity',
    },
  },
  {
    id: 'modern-sectional-transformation',
    title: 'Modern Sectional Transformation',
    category: 'upholstery',
    serviceType: 'sofa-reupholstery',
    description: 'Complete makeover of a tired sectional into a contemporary showpiece. New high-density foam, performance fabric, and clean lines create the perfect family room centerpiece.',
    beforeImage: '/images/portfolio/sectional-before.jpg',
    afterImage: '/images/portfolio/sectional-after.jpg',
    featured: true,
    details: {
      client: 'The Morrison Family',
      duration: '2 weeks',
      fabric: 'Charcoal gray performance linen',
      challenge: 'Updating outdated style while maintaining comfort for young children',
    },
  },
  {
    id: 'leather-recliner-revival',
    title: 'Leather Recliner Revival',
    category: 'upholstery',
    serviceType: 'recliner-upholstery',
    description: 'Favorite recliner given new life with buttery soft leather and mechanism servicing. This beloved chair is now ready for another decade of comfort.',
    beforeImage: '/images/portfolio/recliner-before.jpg',
    afterImage: '/images/portfolio/recliner-after.jpg',
    featured: false,
    details: {
      client: 'Private Residence',
      duration: '1 week',
      fabric: 'Top-grain caramel leather',
      challenge: 'Sourcing exact mechanism parts for 15-year-old recliner',
    },
  },
  {
    id: 'dining-chair-set',
    title: 'Dining Chair Refinishing Set',
    category: 'upholstery',
    serviceType: 'furniture-repair',
    description: 'Complete restoration of six dining chairs including frame repair, wood refinishing, and reupholstering seats in luxurious fabric with brass nail head trim.',
    beforeImage: '/images/portfolio/dining-chairs-before.jpg',
    afterImage: '/images/portfolio/dining-chairs-after.jpg',
    featured: true,
    details: {
      client: 'Riverside Estate',
      duration: '3 weeks',
      fabric: 'Cream damask with brass nail heads',
      challenge: 'Matching wood stain across all six chairs with varying wear',
    },
  },
  {
    id: 'custom-window-seat',
    title: 'Custom Window Seat Cushions',
    category: 'upholstery',
    serviceType: 'loose-cushions',
    description: 'Bespoke window seat cushions with coordinating throw pillows. Perfect fit achieved through precise measurements and expert craftsmanship.',
    beforeImage: '/images/portfolio/window-seat-before.jpg',
    afterImage: '/images/portfolio/window-seat-after.jpg',
    featured: false,
    details: {
      client: 'The Anderson Residence',
      duration: '1 week',
      fabric: 'Floral linen blend with velvet pillows',
      challenge: 'Creating cushions for bay window with unusual angles',
    },
  },

  // Window Treatment Projects
  {
    id: 'window-treatments-gallery',
    title: 'Window Treatments Gallery',
    category: 'window-treatments',
    serviceType: 'window-treatments-showcase',
    description: 'Our expert window treatments portfolio showcasing custom drapes, blinds, shades, and curtains. Each project demonstrates our commitment to combining elegant design with practical functionality. Transform your windows with our curated collection of stunning installations.',
    featured: true,
    galleryImages: [
      {
        id: 'window-1',
        src: '/images/uploads/9378def2-e9a9-48f4-8f67-c6aeb8fa90de.jpg',
        alt: 'Professional Window Treatments - Showcase 1',
        type: 'showcase',
      },
      {
        id: 'window-2',
        src: '/images/uploads/ba0339e9-b429-418a-8485-edf7bf71f109.jpg',
        alt: 'Professional Window Treatments - Showcase 2',
        type: 'showcase',
      },
      {
        id: 'window-3',
        src: '/images/uploads/93320ad2-5591-4a14-a259-ac853e7f09c7.jpg',
        alt: 'Professional Window Treatments - Showcase 3',
        type: 'showcase',
      },
      {
        id: 'window-4',
        src: '/images/uploads/71236379-e8af-41b7-9623-b93faaf61de0.jpg',
        alt: 'Professional Window Treatments - Showcase 4',
        type: 'showcase',
      },
      {
        id: 'window-5',
        src: '/images/uploads/909fae43-4e03-432d-b8a8-b61440f2dcfc.jpg',
        alt: 'Professional Window Treatments - Showcase 5',
        type: 'showcase',
      },
      {
        id: 'window-6',
        src: '/images/uploads/8b9b7649-822b-4947-b0e1-576db9d31969.jpg',
        alt: 'Professional Window Treatments - Showcase 6',
        type: 'showcase',
      },
      {
        id: 'window-7',
        src: '/images/uploads/18b8b210-f419-4e2b-9275-300aa5506988.jpg',
        alt: 'Professional Window Treatments - Showcase 7',
        type: 'showcase',
      },
      {
        id: 'window-8',
        src: '/images/uploads/78c1b460-9251-4f4b-91cd-09d80639ff07.jpg',
        alt: 'Professional Window Treatments - Showcase 8',
        type: 'showcase',
      },
      {
        id: 'window-9',
        src: '/images/uploads/534cae96-f8f4-491b-a09c-4dab4139b464.jpg',
        alt: 'Professional Window Treatments - Showcase 9',
        type: 'showcase',
      },
      {
        id: 'window-10',
        src: '/images/uploads/870f21c3-c19a-480b-8713-963041d17df3.jpg',
        alt: 'Professional Window Treatments - Showcase 10',
        type: 'showcase',
      },
      {
        id: 'window-11',
        src: '/images/uploads/1149b244-f240-452f-8d17-83a40dc34d72.jpg',
        alt: 'Professional Window Treatments - Showcase 11',
        type: 'showcase',
      },
      {
        id: 'window-12',
        src: '/images/uploads/efaed88b-1cbf-4c03-950f-dcff154f8d8d.jpg',
        alt: 'Professional Window Treatments - Showcase 12',
        type: 'showcase',
      },
      {
        id: 'window-13',
        src: '/images/uploads/0cb238d4-8e8d-4616-b15a-c0ad3c3cefa3.jpg',
        alt: 'Professional Window Treatments - Showcase 13',
        type: 'showcase',
      },
      {
        id: 'window-14',
        src: '/images/uploads/24aba686-2796-4c81-a72f-dd002170a39a.jpg',
        alt: 'Professional Window Treatments - Showcase 14',
        type: 'showcase',
      },
      {
        id: 'window-15',
        src: '/images/uploads/5c4af46b-213a-40b8-a24d-912abac6d709.jpg',
        alt: 'Professional Window Treatments - Showcase 15',
        type: 'showcase',
      },
      {
        id: 'window-16',
        src: '/images/uploads/0cb539f4-1abb-4257-a9bd-f3232d495f38.jpg',
        alt: 'Professional Window Treatments - Showcase 16',
        type: 'showcase',
      },
      {
        id: 'window-17',
        src: '/images/uploads/ef5449f4-c05b-4058-916e-6350da392eb0.jpg',
        alt: 'Professional Window Treatments - Showcase 17',
        type: 'showcase',
      },
    ],
    details: {
      client: 'Multiple Clients',
      duration: 'Varies by project',
      fabric: 'Premium window treatment fabrics',
      challenge: 'Custom designs tailored to each space\'s unique requirements',
    },
  },
  {
    id: 'formal-living-room-drapes',
    title: 'Formal Living Room Drapery',
    category: 'window-treatments',
    serviceType: 'custom-curtains',
    description: 'Elegant floor-to-ceiling drapes with custom valances transform this formal living room. Luxurious silk fabric with blackout lining provides both beauty and function.',
    beforeImage: '/images/portfolio/drapes-before.jpg',
    afterImage: '/images/portfolio/drapes-after.jpg',
    featured: true,
    details: {
      client: 'Oakmont Manor',
      duration: '2 weeks',
      fabric: 'Champagne silk dupioni with blackout lining',
      challenge: '14-foot ceilings requiring custom hardware and installation',
    },
  },
  {
    id: 'bedroom-combi-blinds',
    title: 'Master Bedroom Combi Blinds',
    category: 'window-treatments',
    serviceType: 'combi-blinds',
    description: 'Modern combi blinds offering perfect light control in a master bedroom. Sheer and privacy layers create versatile ambiance throughout the day.',
    beforeImage: '/images/portfolio/combi-before.jpg',
    afterImage: '/images/portfolio/combi-after.jpg',
    featured: false,
    details: {
      client: 'Lakeview Condo',
      duration: '3 days',
      fabric: 'White sheer with gray privacy layer',
      challenge: 'Motorization for hard-to-reach windows',
    },
  },
  {
    id: 'home-office-roller-shades',
    title: 'Home Office Solar Shades',
    category: 'window-treatments',
    serviceType: 'roller-shades',
    description: 'Light-filtering solar shades reduce glare while maintaining the view. Perfect solution for home office productivity and comfort.',
    beforeImage: '/images/portfolio/office-shades-before.jpg',
    afterImage: '/images/portfolio/office-shades-after.jpg',
    featured: false,
    details: {
      client: 'Tech Professional Home Office',
      duration: '2 days',
      fabric: '5% openness solar screen fabric',
      challenge: 'Coordinating with multiple monitor setup to eliminate glare',
    },
  },
  {
    id: 'nursery-blackout-curtains',
    title: 'Nursery Blackout Curtains',
    category: 'window-treatments',
    serviceType: 'custom-curtains',
    description: 'Soft, elegant blackout curtains create the perfect sleep environment. Custom embroidered details add a personal, whimsical touch to this nursery.',
    beforeImage: '/images/portfolio/nursery-before.jpg',
    afterImage: '/images/portfolio/nursery-after.jpg',
    featured: true,
    details: {
      client: 'The Parker Family',
      duration: '1 week',
      fabric: 'Soft pink blackout with cloud embroidery',
      challenge: 'Child-safe cordless design with complete light blocking',
    },
  },
];

// Testimonials
export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
  rating: number;
  projectType: string;
  image?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    name: 'Arlene Escalada',
    role: 'Homeowner',
    content: 'Great job. Our living room set turned out to be a brand new furniture. It was done and delivered ahead of time. Very professional, friendly and cordial couple. Thank you again for the magical work. Will call you again and highly recommend you to our friends. God bless! — Arlene and Rich',
    rating: 5,
    projectType: 'Living room set reupholstery',
  },
  {
    id: 'testimonial-2',
    name: 'Elay Franz',
    role: 'Homeowner',
    content: 'I am satisfied and thankful client of Jojo & Jocelyn\'s! They are very hands on, professional and pleasant people. Their work was excellent and they even sent me photo of the interior prior to the delivery date. I can\'t thank them enough that they had restored my sofabed good as new, durable than before, delivered on time and at competitive price. I will be their loyal client. They are truly highly recommended!',
    rating: 5,
    projectType: 'Sofabed re-upholstery',
  },
  {
    id: 'testimonial-3',
    name: 'Tiff Hizon Uy-Tioco',
    role: 'Homeowner',
    content: 'I had an old sofa bed that I had thought about throwing out and replacing. Instead, I decided to ask Jojo and Jocelyn reupholster it. It came out great! The sofa looks brand new and the workmanship was excellent. They even created a new and comfier mattress for the inside of sofa bed. Overall, they were very professional and easy to work with. I even received photo updates on the sofa bed via email. I would definitely recommend them!',
    rating: 5,
    projectType: 'Sofa bed reupholstery',
  },
  {
    id: 'testimonial-4',
    name: 'Elinor Sedilla',
    role: 'Homeowner',
    content: 'My old couch needed reupholstering but reupholstering is not yet in my wish list this year so I opted for a slipcover as it is a less costly solution to keeping the couch clean. When they came to deliver the couch, it looked as if I bought a new one. Great workmanship! Thank you! I will get in touch with you again, Jojo and Jocelyn for future projects.',
    rating: 5,
    projectType: 'Custom slipcover',
  },
  {
    id: 'testimonial-5',
    name: 'Jo Latonero',
    role: 'Family',
    content: 'Have been my sister upholsterer n curtain maker for years. Todate nothing goes wrong repeatedly extra ordinary. Highly recommended. — Lumbang St., Dasmarinas Village Makati',
    rating: 5,
    projectType: 'Upholstery and curtain work',
  },
  {
    id: 'testimonial-6',
    name: 'George Alan Esleta',
    role: 'Homeowner',
    content: 'Reupholstery of my 3-seater sofa was done professionally and very quickly. Regular photo updates from Ate Jocelyn! Will definitely recommend them!',
    rating: 5,
    projectType: '3-seater sofa reupholstery',
  },
  {
    id: 'testimonial-7',
    name: 'Lulu Baclogan',
    role: 'Homeowner',
    content: 'We moved to a new place, so also wanted new furnitures. But with soaring prices, we went instead for reupholstering of sofa and dining chairs. They were quite accommodating and very convenient. I was so pleased with the results - the cut and placement of the fabric was perfect. But the best thing is the honesty of their workers and the couple. They found 2 mobile phones inside our furniture and brought both back! Thanks for your honesty and job well done!',
    rating: 5,
    projectType: 'Sofa and dining chairs reupholstery',
  },
];

// Why Choose Us highlights
export const whyChooseUs = [
  {
    icon: 'Award',
    title: 'Expert Craftsmanship',
    description: 'Over 25 years of combined experience in upholstery and window treatments. Every piece receives meticulous attention from our master craftsmen.',
  },
  {
    icon: 'Clock',
    title: 'Fast Turnaround',
    description: 'We understand you want your space complete. Most projects are completed within 1-3 weeks without compromising quality.',
  },
  {
    icon: 'Palette',
    title: 'Extensive Fabric Selection',
    description: 'Access to thousands of premium fabrics from leading manufacturers. From classic to contemporary, we help you find the perfect material.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Quality Guaranteed',
    description: 'We stand behind our work with comprehensive warranties. Your satisfaction and the longevity of our craftsmanship are our top priorities.',
  },
  {
    icon: 'Users',
    title: 'Personalized Service',
    description: 'Direct communication with our craftsmen throughout your project. We listen to your vision and make it reality.',
  },
  {
    icon: 'Home',
    title: 'In-Home Consultation',
    description: 'We come to you with fabric samples and expert advice. See materials in your lighting and alongside your existing decor.',
  },
];
